// Reusable Anthropic model picker — shared by the Agent Console, the Quality
// Co-Pilot portal, and the Tech Support (Kirk) portal. A plain native <select>
// (matching the profile picker) listing the registry models. The selected value
// rides on the conversation (last-turn-wins) and is sent with each turn.
//
// If `value` isn't in the catalog (e.g. a legacy/disabled model on an old
// conversation, like a retired default), it is shown as a leading "(unavailable)"
// option so the control reflects reality instead of silently snapping to model 0.

import type { ModelOption } from '../../services/agentConsole';

interface ModelSelectProps {
  models: ModelOption[];
  value: string;
  onChange: (modelId: string) => void;
  disabled?: boolean;
  title?: string;
  id?: string;
}

export default function ModelSelect({
  models,
  value,
  onChange,
  disabled = false,
  title = 'Model for this conversation',
  id,
}: ModelSelectProps) {
  const known = models.some((m) => m.id === value);
  return (
    <select
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      title={title}
      aria-label={title}
      style={{
        fontSize: 12,
        fontWeight: 600,
        color: '#4f46e5',
        background: '#eef2ff',
        border: '1px solid #c7d2fe',
        borderRadius: 8,
        padding: '5px 8px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        maxWidth: 220,
      }}
    >
      {!known && value ? (
        <option value={value}>{value} (unavailable)</option>
      ) : null}
      {models.map((m) => (
        <option key={m.id} value={m.id} title={m.blurb}>
          {m.label} · {m.relative_cost}
        </option>
      ))}
    </select>
  );
}
